<template>
    <div class="button">
        <slot></slot>
    </div>
</template>

<script>
    //import Component from 'path/to/component'

    export default {
        beforeCreate: function () {

        },
        beforeDestroy: function () {

        },
        beforeMount: function () {

        },
        beforeUpdate: function () {

        },
        components: {},
        computed: {},
        created: function () {

        },
        data() {
            return {}
        },
        destroyed: function () {

        },
        methods: {},
        mounted: function () {

        },
        name: 'btn',
        props: {},
        updated: function () {

        },
        watch: {}
    }
</script>

<style lang="scss">
    .button{
        color: $main-white;
        cursor: pointer;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        font-weight: $bold;
        padding: 6px 20px;
        text-align: center;
        //text-transform: uppercase;
        transition-property: background-color, color, opacity;
        position: relative;
        border-radius: var(--input-radius);
        line-height: 1.125;
        height: auto;
        min-height: 38px;

        &.default{
            background-color: transparent;
            color: $main-black;

            &:hover{
                background-color: lighten($main-color,35%);
            }
        }

        &.primary{
            background-color: $secondary-color;

            &:hover{
                background-color: darken($secondary-color,10%);
            }
        }

        &.secondary{
            background-color: $main-color;

            &:hover{
                background-color: darken($main-color,10%);
            }
        }

        &.info{
            background-color: $info;

            &:hover{
                background-color: darken($info,10%);
            }
        }

        &.success{
            background-color: $success;

            &:hover{
                background-color: darken($success,10%);
            }
        }

        &.error,&.danger{
            background-color: $error;

            &:hover{
                background-color: darken($error,10%);
            }
        }

        &.warning{
            background-color: $warning;

            &:hover{
                background-color: darken($warning,10%);
            }
        }

        &.white{
            background-color: $main-white;
            color: $main-black;

            &:hover{
                background-color: lighten($secondary-color,55%);
            }
        }

        &.google{
            background-color: #4285F4;
            padding-left: 50px;

            svg{
                position: absolute;
                left: 0;
                top: 0;
                height: 100%;
            }

            &:hover{
                background-color: darken(#4285F4,10%);
            }
        }

        &.pull-right{
            float: right;
        }

        &.pull-left{
            float: left;
        }

        &.block{
            float: none;
            display: flex;
            width: auto;
            &:not(:first-child){
                margin-top: 10px;
            }
        }

        .svg-inline--fa{
            margin-right: 10px;

            &.pull-right{
                position: absolute;
                right: 5px;
            }
        }



        &.disabled,&:disabled{
            opacity: 0.5;
            pointer-events: none;
        }


    }
</style>


// WEBPACK FOOTER //
// src/components/ui/Button.vue